// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
* VARIABLES
*/
/*
* MIXINS
*/
.Skeleton {
  background-color: rgba(109, 109, 110, 0.8);
  margin: 10px 0;
  border-radius: 4px;
}
.Skeleton__inline {
  display: inline-flex;
  align-items: center;
  width: 100%;
}
.Skeleton.title {
  width: 70%;
  height: 35px;
  margin-bottom: 15px;
  background-image: linear-gradient(270deg, #333, rgba(66, 66, 66, 0.2), rgba(66, 66, 66, 0.2), #333);
  background-size: 400% 100%;
  border-radius: 5px;
  animation: shine 5s ease-in-out infinite;
}
@media (min-width: 768px) {
  .Skeleton.title {
    width: 55%;
  }
}
@media (min-width: 1024px) {
  .Skeleton.title {
    width: 25%;
    height: 40px;
    margin-bottom: 20px;
  }
}
.Skeleton.button {
  display: inline-block;
  width: 20%;
  height: 40px;
  margin-bottom: 15px;
  margin-right: 15px;
  background-image: linear-gradient(270deg, #333, rgba(66, 66, 66, 0.2), rgba(66, 66, 66, 0.2), #333);
  background-size: 400% 100%;
  border-radius: 5px;
  animation: shine 5s ease-in-out infinite;
}
@media (min-width: 1024px) {
  .Skeleton.button {
    width: 10%;
    height: 45px;
    margin-bottom: 20px;
  }
}
.Skeleton.text {
  width: 90%;
  height: 15px;
  background-image: linear-gradient(270deg, #333, rgba(66, 66, 66, 0.2), rgba(66, 66, 66, 0.2), #333);
  background-size: 400% 100%;
  border-radius: 5px;
  animation: shine 5s ease-in-out infinite;
}
@media (min-width: 768px) {
  .Skeleton.text {
    width: 70%;
  }
}
@media (min-width: 1024px) {
  .Skeleton.text {
    width: 40%;
    height: 20px;
  }
}
.Skeleton__Page .title {
  width: 45%;
}
@media (min-width: 640px) {
  .Skeleton__Page .title {
    width: 35%;
  }
}
@media (min-width: 768px) {
  .Skeleton__Page .title {
    width: 33%;
  }
}
@media (min-width: 1024px) {
  .Skeleton__Page .title {
    width: 25%;
  }
}
.Skeleton.poster {
  position: relative;
  display: inline-block;
  width: 100%;
  min-height: 110px;
  background-color: #2d2d2d;
  white-space: normal;
  vertical-align: top;
  border-left: 2px solid #141414;
  border-right: 2px solid #141414;
  margin-bottom: 4vw;
  border-radius: 5px;
  animation: 2.5s ease-in-out 0s pulse infinite;
  transition: background-color 0.1s ease-in-out;
}
@media (min-width: 330px) {
  .Skeleton.poster {
    width: 50%;
    min-height: 130px;
  }
}
@media (min-width: 625px) {
  .Skeleton.poster {
    width: 33.3%;
    min-height: 150px;
  }
}
@media (min-width: 998px) {
  .Skeleton.poster {
    width: 25%;
  }
}
@media (min-width: 1378px) {
  .Skeleton.poster {
    width: 16.6%;
  }
}
.Skeleton.poster:nth-child(1) {
  animation-delay: 0.1388888889s;
}
.Skeleton.poster:nth-child(2) {
  animation-delay: 0.2777777778s;
}
.Skeleton.poster:nth-child(3) {
  animation-delay: 0.4166666667s;
}
.Skeleton.poster:nth-child(4) {
  animation-delay: 0.5555555556s;
}
.Skeleton.poster:nth-child(5) {
  animation-delay: 0.6944444444s;
}
.Skeleton.poster:nth-child(6) {
  animation-delay: 0.8333333333s;
}

@keyframes shine {
  0% {
    background-position: 200% 0;
  }
  to {
    background-position: -200% 0;
  }
}
@keyframes pulse {
  25% {
    background-color: rgba(255, 255, 255, 0.2);
  }
  50% {
    background-color: #2d2d2d;
  }
}`, "",{"version":3,"sources":["webpack://./src/scss/_mixin.scss","webpack://./src/components/SkeletonElement/skeletonElement.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKA;;CAAA;ACSA;EACE,0CAAA;EACA,cAAA;EACA,kBAAA;AAPF;AASE;EACE,oBAAA;EACA,mBAAA;EACA,WAAA;AAPJ;AAUE;EACE,UAAA;EACA,YAAA;EACA,mBAAA;EAnBF,mGAAA;EACA,0BAAA;EACA,kBAAA;EAmBE,wCAAA;AANJ;ADoDQ;ECnDN;IAQI,UAAA;EALJ;AACF;AD+CQ;ECnDN;IAYI,UAAA;IACA,YAAA;IACA,mBAAA;EAJJ;AACF;AAQE;EACE,qBAAA;EACA,UAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EAxCF,mGAAA;EACA,0BAAA;EACA,kBAAA;EAwCE,wCAAA;AAJJ;AD6BQ;EChCN;IAUI,UAAA;IACA,YAAA;IACA,mBAAA;EAHJ;AACF;AAME;EACE,UAAA;EACA,YAAA;EArDF,mGAAA;EACA,0BAAA;EACA,kBAAA;EAqDE,wCAAA;AAFJ;ADcQ;EChBN;IAOI,UAAA;EADJ;AACF;ADSQ;EChBN;IAWI,UAAA;IACA,YAAA;EAAJ;AACF;AAII;EACE,UAAA;AAFN;ADAQ;ECCJ;IAII,UAAA;EADN;AACF;ADLQ;ECCJ;IAOI,UAAA;EACN;AACF;ADVQ;ECCJ;IAUI,UAAA;EAGN;AACF;AACE;EACE,kBAAA;EACA,qBAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,kBAAA;EACA,kBAAA;EACA,6CAAA;EACA,6CAAA;AACJ;AD9BQ;ECgBN;IAgBI,UAAA;IACA,iBAAA;EAEJ;AACF;ADpCQ;ECgBN;IAoBI,YAAA;IACA,iBAAA;EAIJ;AACF;AD1CQ;ECgBN;IAwBI,UAAA;EAMJ;AACF;AD/CQ;ECgBN;IA2BI,YAAA;EAQJ;AACF;AAHM;EACE,8BAAA;AAKR;AANM;EACE,8BAAA;AAQR;AATM;EACE,8BAAA;AAWR;AAZM;EACE,8BAAA;AAcR;AAfM;EACE,8BAAA;AAiBR;AAlBM;EACE,8BAAA;AAoBR;;AAdA;EACE;IACE,2BAAA;EAiBF;EAfA;IACE,4BAAA;EAiBF;AACF;AAdA;EACE;IACE,0CA5IU;EA4JZ;EAbA;IACE,yBAAA;EAeF;AACF","sourcesContent":["/*\n* VARIABLES\n*/\n$breakpoints: (ll: 1450px, lg: 1024px, md: 768px, sm: 640px, xs: 400px) !default;\n\n/*\n* MIXINS\n*/\n@mixin mq($min: null, $max: null) {\n    $min-type: type-of($min);\n    $max-type: type-of($max);\n\n    @if $min-type==string {\n        @if $min==xs {\n            $min: \"(min-width: #{map-get($breakpoints, xs)})\";\n        }\n        @else if $min==sm {\n            $min: \"(min-width: #{map-get($breakpoints, sm)})\";\n        }\n        @else if $min==md {\n            $min: \"(min-width: #{map-get($breakpoints, md)})\";\n        }\n        @else if $min==lg {\n            $min: \"(min-width: #{map-get($breakpoints, lg)})\";\n        }\n        @else if $min==ll {\n            $min: \"(min-width: #{map-get($breakpoints, ll)})\";\n        }\n        @else {\n            @warn \"mq mixin supports: sm, md, lg, ll\";\n        }\n    }\n    @else if $min-type==number {\n        $min: \"(min-width: #{$min})\";\n    }\n\n    @if $max-type==string {\n        @if $max==xs {\n            $max: \"(max-width: #{map-get($breakpoints, xs) - 1})\";\n        }\n        @else if $max==sm {\n            $max: \"(max-width: #{map-get($breakpoints, sm) - 1})\";\n        }\n        @else if $max==md {\n            $max: \"(max-width: #{map-get($breakpoints, md) - 1})\";\n        }\n        @else if $max==lg {\n            $max: \"(max-width: #{map-get($breakpoints, lg) - 1})\";\n        }\n        @else if $max==ll {\n            $max: \"(max-width: #{map-get($breakpoints, ll) - 1})\";\n        }\n        @else {\n            @warn \"mq mixin supports: xs, sm, md, lg, ll\";\n        }\n    }\n\n    @else if $max-type==number {\n        $max: \"(max-width: #{$max})\";\n    }\n\n    $query: false;\n    @if $min and $max {\n        $query: \"#{$min} and #{$max}\";\n    }\n    @else if $min {\n        $query: \"#{$min}\";\n    }\n    @else if $max {\n        $query: \"#{$max}\";\n    }\n\n    @if (not $query) {\n        @warn \"Invalid media query\";\n    }\n    @else {\n        @media #{$query} {\n            @content;\n        }\n    }\n}\n\n@mixin mob() {\n    @include mq(null, md) {\n        @content;\n    }\n}\n\n@mixin smart() {\n    @include mq(null, sm) {\n        @content;\n    }\n}\n\n@mixin tab-portrait() {\n    @include mq(sm, md) {\n        @content;\n    }\n}\n\n@mixin tab-landscape() {\n    @include mq(md, lg) {\n        @content;\n    }\n}\n\n@mixin desk() {\n    @include mq(lg) {\n        @content;\n    }\n}","@import '../../scss/mixin';\n@import '../../scss/variables';\n\n$shine-color: rgba(255,255,255,0.2);\n$animation-duration: 5s;\n$easing-function: ease-in-out;\n$iteration-count: infinite;\n\n@mixin background-gradient {\n  background-image: linear-gradient(270deg, #333, rgba(#424242, 0.2), rgba(#424242, 0.2), #333);\n  background-size: 400% 100%;\n  border-radius: 5px;\n}\n\n.Skeleton {\n  background-color: rgba(#6d6d6e, 0.8);\n  margin: 10px 0;\n  border-radius: 4px;\n\n  &__inline {\n    display: inline-flex;\n    align-items: center;\n    width: 100%;\n  }\n\n  &.title {\n    width: 70%;\n    height: 35px;\n    margin-bottom: 15px;\n    @include background-gradient;\n    animation: shine $animation-duration $easing-function $iteration-count;\n\n    @include mq('md') {\n      width: 55%;\n    }\n\n    @include mq('lg') {\n      width: 25%;\n      height: 40px;\n      margin-bottom: 20px;\n    }\n  }\n\n\n  &.button {\n    display: inline-block;\n    width: 20%;\n    height: 40px;\n    margin-bottom: 15px;\n    margin-right: 15px;\n    @include background-gradient;\n    animation: shine $animation-duration $easing-function $iteration-count;\n\n    @include mq('lg') {\n      width: 10%;\n      height: 45px;\n      margin-bottom: 20px;\n    }\n  }\n\n  &.text {\n    width: 90%;\n    height: 15px;\n    @include background-gradient;\n    animation: shine $animation-duration $easing-function $iteration-count;\n\n    @include mq('md') {\n      width: 70%;\n    }\n\n    @include mq('lg') {\n      width: 40%;\n      height: 20px;\n    }\n  }\n\n  &__Page {\n    .title {\n      width: 45%;\n\n      @include mq('sm') {\n        width: 35%;\n      }\n      @include mq('md') {\n        width: 33%;\n      }\n      @include mq('lg') {\n        width: 25%;\n      }\n    }\n  }\n\n  &.poster {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n    min-height: 110px;\n    background-color: #2d2d2d;\n    white-space: normal;\n    vertical-align: top;\n    border-left: 2px solid $black;\n    border-right: 2px solid $black;\n    margin-bottom: 4vw;\n    border-radius: 5px;\n    animation: 2.5s $easing-function 0s pulse $iteration-count;\n    transition: background-color 0.1s $easing-function;\n\n    @include mq(330px) {\n      width: 50%;\n      min-height: 130px;\n    }\n    @include mq(625px) {\n      width: 33.3%;\n      min-height: 150px;\n    }\n    @include mq(998px) {\n      width: 25%;\n    }\n    @include mq(1378px) {\n      width: 16.6%;\n    }\n  }\n\n  @for $i from 1 through 6 {\n    &.poster {\n      &:nth-child(#{$i}) {\n        animation-delay: $i * (calc(2.5s / 18));\n      }\n    }\n  }\n}\n\n@keyframes shine {\n  0% {\n    background-position: 200% 0;\n  }\n  to {\n    background-position: -200% 0;\n  }\n}\n\n@keyframes pulse {\n  25% {\n    background-color: $shine-color;\n  }\n\n  50% {\n    background-color: #2d2d2d;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
